

import { useQuery } from "@tanstack/react-query";
import type { SellerWithStoresResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseAdminSellerByIdQueryParams = {
  sellerId: string;
};

export function useSellerByIdQuery({ sellerId }: UseAdminSellerByIdQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.sellerById(sellerId),
    queryFn: () => apiJsonClient<SellerWithStoresResponse>(endpoints.admin.sellerById(sellerId)),
    enabled: sellerId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
